module.exports = __webpack_public_path__ + "img/29400.7a2a1178.jpg";